import React, { useState, useRef, useEffect } from "react";
import emailjs from '@emailjs/browser';

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const formRef = useRef(null);

  // EmailJS config (reuse from ContactForm.js)
  const SERVICE_ID = 'hirareml-zoho';
  const TEMPLATE_ID = 'rareml-contact-template';
  const PUBLIC_KEY = '83w7DYVocZoV0DGiq';

  useEffect(() => {
    emailjs.init(PUBLIC_KEY);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)) {
      setError("Please enter a valid email address.");
      return;
    }
    // Send email using EmailJS
    emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        email,
        message: `GDPR Account Deletion Request for: ${email}`,
        to_email: 'hi@rareml.ai',
        name: email,
      },
      PUBLIC_KEY
    )
      .then(() => {
        setSubmitted(true);
      })
      .catch(() => {
        setError('Sorry, something went wrong. Please try again later.');
      });
  };

  return (
    <div style={{ maxWidth: 400, margin: "2rem auto", padding: "1rem" }}>
      <h1>Delete Account</h1>
      <p>
        To request deletion of your account and personal data, please enter your email address below. We will process your request in accordance with GDPR regulations.
      </p>
      {submitted ? (
        <div style={{ color: "green" }}>
          <strong>Your request has been submitted.</strong>
          <p>We will contact you at {email} to confirm and complete the deletion process.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} ref={formRef}>
          <label htmlFor="email">Email Address:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: "100%", margin: "0.5rem 0", padding: "0.5rem" }}
          />
          {error && <div style={{ color: "red" }}>{error}</div>}
          <button type="submit" className="inspired-btn" style={{ width: '100%' }}>
            Request Deletion
          </button>
        </form>
      )}
    </div>
  );
};

export default DeleteAccount;
